import { render, staticRenderFns } from "./BracketItemPlayer.vue?vue&type=template&id=165395b8&scoped=true"
import script from "./BracketItemPlayer.vue?vue&type=script&lang=js"
export * from "./BracketItemPlayer.vue?vue&type=script&lang=js"
import style0 from "./BracketItemPlayer.vue?vue&type=style&index=0&id=165395b8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "165395b8",
  null
  
)

export default component.exports